module.exports = "<app-stock-list></app-stock-list>\n"


//////////////////
// WEBPACK FOOTER
// /home/travis/build/nishant95/stocks-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main